import { Link } from "react-router-dom"
import { classNames } from "utils/ClassNames"
import { UniqueGradient } from "./UniqueGradient"
import dayjs from "dayjs"
import { LockClosedIcon, LockOpenIcon } from "@heroicons/react/24/outline"

type Props = {
  id: string
  isSelected: boolean
  name: string
  subtitle?: string
  slug?: string
  opensAt?: string
  onClick?: () => void
}

export const TimeCapsuleListItem = (props: Props) => {
  const { id, slug, isSelected, name, subtitle, opensAt, onClick } = props

  return (
    <li key={id}>
      <Link
        to={`/time-capsules/${slug}`}
        onClick={onClick}
        className={classNames(
          "text-gray-700 hover:bg-gray-50 hover:text-primary-600 group flex gap-x-3 rounded-md p-2 text-sm/6 font-semibold items-center",
          isSelected ? "bg-gray-50 text-primary-600" : ""
        )}
      >
        <UniqueGradient
          id={id}
          className="h-6 w-6 shrink-0 rounded-md flex items-center justify-center"
        >
          {opensAt && dayjs(opensAt).isAfter(dayjs()) ? (
            <LockClosedIcon aria-hidden="true" className="h-4 w-4 text-white" />
          ) : (
            <LockOpenIcon aria-hidden="true" className="h-4 w-4 text-white" />
          )}
        </UniqueGradient>
        <div className="flex flex-col">
          <span className="truncate">{name}</span>
          {subtitle && (
            <span className="truncate text-xs/4 mb-1 font-semibold text-gray-400">
              {subtitle}
            </span>
          )}
          <span className="text-xs/4 font-semibold text-gray-400">
            {opensAt && dayjs(opensAt).isAfter(dayjs())
              ? dayjs(opensAt).format("MMM D, YYYY")
              : "Open"}
          </span>
        </div>
      </Link>
    </li>
  )
}
